export const GRADIENT = 'gradient';
export const DEFAULT = 'default';
export const BORDERLESS_FILLED = 'borderless-filled';
